@if (visible()) {
  <button
    type="button"
    class="app-update-chip"
    data-test-id="app-update-indicator"
    [title]="'platform.appUpdate.indicatorTitle' | transloco"
    (click)="update.reopenDialog()"
  >
    <i class="fas fa-arrows-rotate" aria-hidden="true"></i>
    <span class="app-update-chip__label">{{ 'platform.appUpdate.indicator' | transloco }}</span>
  </button>
}
